import { apiClient } from './client';

export type ServiceStatus = 'ok' | 'stale' | 'down';

export interface ServiceHealth {
  name: string;
  status: ServiceStatus;
  response_ms: number | null;
  detail: string;
  version: string | null;
}

export interface SystemStatusSnapshot {
  checked_at: string;
  services: ServiceHealth[];
}

export async function getSystemStatus(): Promise<SystemStatusSnapshot> {
  const { data } = await apiClient.get<SystemStatusSnapshot>(
    '/api/v1/admin/system-status',
  );
  return data;
}

export interface StatusHistoryBucket {
  bucket_start: string;
  status: ServiceStatus | null;
}

export interface ServiceHistory {
  service_name: string;
  buckets: StatusHistoryBucket[];
}

export interface SystemStatusHistory {
  window_hours: number;
  bucket_minutes: number;
  services: ServiceHistory[];
}

export async function getSystemStatusHistory(
  hours = 168,
  bucketMinutes = 60,
): Promise<SystemStatusHistory> {
  const { data } = await apiClient.get<SystemStatusHistory>(
    '/api/v1/admin/system-status/history',
    { params: { hours, bucket_minutes: bucketMinutes } },
  );
  return data;
}
